import React from 'react';

import UsuariosForm from './UsuariosForm';
import UsuariosListagem from './UsuariosListagem';

import { useParams } from 'react-router';
import TitleModule from '../../../components/title/TitleModule';



const Usuarios = props => {
    
    const params = useParams();
    const title = ["Revendedoras"];
    if(params.acao && params.acao === "form") {
        if(params.id){
            title.push("Editar");
        } else {
            title.push("Criar");
        }
    } else {
        title.push("Listagem");
    }
    return (
        <>
            <TitleModule titulo={title.join(' > ')} />
            { params.acao && params.acao === 'form' && <UsuariosForm />}
            { !params.acao && <UsuariosListagem />}
        </>
    )
};

export default Usuarios;